
const UPDATE_USER = (state = {}, action) =>{
    switch(action.type){
        case 'UPDATE_USER_PERMISSIONS' : 
            return {...state ,permissions : action.payload }
        case 'UPDATE_USER_DETAILS' : 
            return {...state ,user_details : action.payload}
        case 'IS_SADDLEPOINT_USER' : 
            return {...state ,is_saddlepoint_user : action.payload}    
        default : return state
    }
}

export {UPDATE_USER}